module.exports = __webpack_public_path__ + "img/robot_dabi.asm.daaca143.jpg";